import React from "react";
import Nav from "../Components/Nav";
import Footer from "../Components/Footer";
import ContactForm from "../Components/ContactForm";
import "./index.less";
import {Flex} from "antd";
import {useTranslation} from "react-i18next";

const aboutItems = [
    {img: 'http://47.115.148.248:9000/officeweb/about/about-001.jpg', text: "Sustainability"},
    {img: 'http://47.115.148.248:9000/officeweb/about/about-002.jpg', text: "News"},
    {img: 'http://47.115.148.248:9000/officeweb/about/about-003.jpg', text: "Events"},
    {img: 'http://47.115.148.248:9000/officeweb/about/about-004.jpg', text: "Lord Bamford"},
    {img: 'http://47.115.148.248:9000/officeweb/about/about-005.jpg', text: "Our Story"},
    {img: 'http://47.115.148.248:9000/officeweb/about/about-006.jpg', text: "How to Find us"},
];

export default function About() {
    const {t} = useTranslation();

    const contactInfo = [
        {label: t('about.addressLabel') + ":", value: t('about.address')},
        {label: "What'sApp:", value: "+86 15716377150", link: "https://wa.me/8615716377150"},
        {label: t('about.email') + ":", value: "guohaolei@yunchijixie.com", link: "mailto:guohaolei@yunchijixie.com"},
        {label: t('about.companyName') + ":", value: "Henan Yunchi Machinery Equipment Co., Ltd."},
    ];
    return (
        <div className="about-page">
            <Nav/>
            <div className="hero-section">
                <div className="hero-bg"/>
                <div className="hero-overlay"/>
                <div className="hero-content">
                    <h1 className="hero-title">About Us</h1>
                    <p className="hero-subtitle">Leading Innovation in Industrial Machinery</p>
                </div>
            </div>
            <div className="main-content">
                <div className="content-wrapper">
                    <div className="image-grid-section">
                        <div className="grid-header">
                            <span className="grid-line"/>
                            <h2>Our Highlights</h2>
                            <span className="grid-line"/>
                        </div>
                        <div className="image-grid">
                            {aboutItems.map((item, index) => (
                                <div
                                    key={index}
                                    className={`grid-item ${[0, 1].includes(index) ? "grid-large" : "grid-small"}`}
                                >
                                    <div className="grid-content">
                                        <img src={item.img} alt={item.text}/>
                                        <div className="grid-overlay">
                                            <span className="grid-text">{item.text}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="contact-section">
                        <div className="contact-card">
                            <div className="contact-header">
                                <div className="contact-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 18V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V6H12C10.9 6 10 6.9 10 8V16C10 17.1 10.9 18 12 18H21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <h3>{t('about.contactInfo')}</h3>
                            </div>
                            <div className="contact-list">
                                {contactInfo.map((info, index) => (
                                    <div key={index} className="contact-item">
                                        <span className="contact-label">{info.label}</span>
                                        {info.link ? (
                                            <a className="contact-value" href={info.link} target="_blank" rel="noopener noreferrer">{info.value}</a>
                                        ) : (
                                            <span className="contact-value">{info.value}</span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <ContactForm />
                </div>
            </div>
            <Footer/>
        </div>
    );
}